export default "__VITE_ASSET__BFiEFQLw__"